import { render, staticRenderFns } from "./ProjectsMenu.vue?vue&type=template&id=125ac987&scoped=true"
import script from "./ProjectsMenu.vue?vue&type=script&lang=js"
export * from "./ProjectsMenu.vue?vue&type=script&lang=js"
import style0 from "./ProjectsMenu.vue?vue&type=style&index=0&id=125ac987&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ac987",
  null
  
)

export default component.exports